<template>
  <div>
    <b-modal id="modalFormListCardPools" ref="modalFormListCardPools" :title="$t('Cards pool')" hide-footer size="lg">
      <div v-if="editItem">
        <b-button size="sm" @click="addCardPool" variant="success" >{{ $t('Add') }}</b-button>
        <b-button size="sm" @click="blockCard" variant="danger">{{ $t('To block') }}</b-button>
        <b-button size="sm" @click="unblockCard" variant="success">{{ $t('Unblock') }}</b-button>
        <b-table sticky-header striped hover small class="mt-2"
          :items="cardItems"
          :fields="cardFields"
          selectable
          select-mode="single"
          @row-clicked="rowClickCard">
          <template v-slot:cell(blocked)="data">
            <b-form-checkbox disabled v-model="data.value"/>
          </template>
        </b-table>
        <b-button size="sm" @click="showModalSystemUsers" variant="success">{{ $t('Add') }}</b-button>
        <b-table sticky-header striped hover small class="mt-2"
          :items="ownerItems"
          :fields="ownerFields">
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click.stop="ClickOnDeleteButton(row)" id="transparent">
              <b-img :src='deleteImage'/>
            </b-button>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="hideModalFormListCard">Ok</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal ref="modalSystemUsers" id="modalSystemUsers" hide-footer :title="$t('System users')">
      <b-table sticky-header striped hover small
      :items="systemUsers"
      :fields="systemUsersFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickSystemUser">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addSystemUsers">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$bvModal.hide('modalSystemUsers')">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <FormAdd :selectedCardPools="cardPools" v-if="cardPools" :editItem="editItem"/>
  </div>
</template>

<script>
import moment from 'moment'
import FormAdd from './formAdd'
export default {
  components: {
    FormAdd
  },
  props: {
    editItem: null
  },
  data () {
    return {
      cardPools: null,
      systemUsersFields: [
        {key: 'user_id', label: 'ID', sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'ip4', label: this.$i18n.t('IPv4 subnet'), sortable: true},
        {key: 'ip6', label: this.$i18n.t('IPv6 subnet'), sortable: true}
      ],
      deleteImage: require('@/assets/img/document_delete.png'),
      currentSystemUser: null,
      currentCard: null,
      cardFields: [
        {key: 'card_id', label: this.$i18n.t('Card ID'), sortable: true},
        {key: 'blocked', label: this.$i18n.t('Blocked'), sortable: true},
        {key: 'secret', label: this.$i18n.t('PIN code'), sortable: true},
        {key: 'balance', label: this.$i18n.t('Balance'), sortable: true},
        {key: 'nameCurrency', label: this.$i18n.t('Currency'), sortable: true},
        {key: 'expire', label: this.$i18n.t('Activate before'), sortable: true},
        {key: 'days', label: this.$i18n.t('Period before'), sortable: true},
        {key: 'is_used', label: this.$i18n.t('Activated'), sortable: true},
        {key: 'tp_id', label: this.$i18n.t('Tariff'), sortable: true}
      ],
      ownerFields: [
        {key: 'id', label: this.$i18n.t('Owner ID'), sortable: true},
        {key: 'name', label: this.$i18n.t('Owner name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions')}
      ]
    }
  },
  methods: {
    rowClickCard (row) {
      this.currentCard = row
    },
    rowClickSystemUser (row) {
      this.currentSystemUser = row
    },
    hideModalFormListCard () {
      this.$store.dispatch('Users/GET_CARD_POOLS')
      this.$refs.modalFormListCardPools.hide()
    },
    blockCard () {
      if (this.currentCard) {
        let blockCard = {
          card_id: this.currentCard.card_id
        }
        let response = this.$store.dispatch('Users/BLOCK_CARD_POOL', blockCard)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$store.dispatch('Users/GET_CARD_POOL', this.editItem.pool_id).then(response => {
              this.editItem.info = this.$store.getters['Users/CARD_POOL'].info
            })
            this.currentCard = null
            this.$root.$emit('makeToasts')
          }
        })
      }
    },
    unblockCard () {
      if (this.currentCard) {
        let unblockCard = {
          card_id: this.currentCard.card_id
        }
        let response = this.$store.dispatch('Users/UNBLOCK_CARD_POOL', unblockCard)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$store.dispatch('Users/GET_CARD_POOL', this.editItem.pool_id).then(response => {
              this.editItem.info = this.$store.getters['Users/CARD_POOL'].info
            })
            this.currentCard = null
            this.$root.$emit('makeToasts')
          }
        })
      }
    },
    showModalSystemUsers () {
      this.currentSystemUser = null
      this.$refs.modalSystemUsers.show()
    },
    ClickOnDeleteButton (row) {
      let delOwner = {
        pool_id: this.editItem.pool_id,
        owner_id: row.item.id
      }
      let response = this.$store.dispatch('Users/DELETE_CARD_POOL_OWNER', delOwner)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Users/GET_CARD_POOL', this.editItem.pool_id).then(response => {
            this.editItem.owners = this.$store.getters['Users/CARD_POOL'].owners
          })
          this.$root.$emit('makeToasts')
        }
      })
    },
    addSystemUsers () {
      if (!this.currentSystemUser) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select system users'), 'Error')
        return
      }
      for (let el of this.editItem.owners) {
        if (el === this.currentSystemUser.user_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This system users is already used in this pool'), 'Error')
          return
        }
      }
      let newSystemUser = {
        owner_id: 0,
        pool_id: 0
      }
      newSystemUser.owner_id = this.currentSystemUser.user_id
      newSystemUser.pool_id = this.editItem.pool_id
      let response = this.$store.dispatch('Users/CREATE_CARD_POOL_OWNER', newSystemUser)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Users/GET_CARD_POOL', this.editItem.pool_id).then(response => {
            this.editItem.owners = this.$store.getters['Users/CARD_POOL'].owners
          })
          this.$refs.modalSystemUsers.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    addCardPool () {
      this.cardPools = {
        pool_id: this.editItem.pool_id,
        size: 100,
        balance: '',
        sec_size: 8,
        currency: 810,
        delay: 100,
        days: 0,
        service_id: 0,
        random: 0,
        expire: moment().format('YYYY-MM-DDThh:mm')
      }
      this.$root.$emit('bv::show::modal', 'modalFormAddCardPools', '#btnShow')
    }
  },
  computed: {
    cardItems () {
      let copy = JSON.parse(JSON.stringify(this.editItem.info))
      for (let el of copy) {
        el.expire = moment(Number(el.expire) * 1000).format('DD-MM-YYYY')
        if (el.is_used === 1) {
          el.is_used = this.$i18n.t('Yes')
        } else {
          el.is_used = this.$i18n.t('No')
        }
        if (el.is_blocked === 1) {
          el.blocked = true
        } else {
          el.blocked = false
        }
        for (let elCurrency of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/CURRENCIES']))) {
          if (elCurrency.currency_id === el.currency) {
            el.nameCurrency = elCurrency.currency_brief_name
            break
          }
        }
      }
      return copy
    },
    ownerItems () {
      let tmp = []
      let copy = JSON.parse(JSON.stringify(this.editItem.owners))
      for (let el of copy) {
        for (let elSystemUsers of this.$store.getters['Users/SYSTEM_USERS']) {
          if (el === elSystemUsers.user_id) {
            let newOwner = {
              'id': 0,
              'name': ''}
            newOwner.id = elSystemUsers.user_id
            newOwner.name = elSystemUsers.login
            tmp.push(newOwner)
          }
        }
      }
      return tmp
    },
    systemUsers () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Users/SYSTEM_USERS']))
      for (let el of copy) {
        el.ip4 = el.ip4 + '/' + el.mask4
        el.ip6 = el.ip6 + '/' + el.mask6
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/cardPools/formListCard.vue